import { GetterTree } from 'vuex'
import { RootState } from '@/store'
import { ProjectsState } from '@/store/projects'

export const getters: GetterTree<ProjectsState, RootState> = {
    requestParams(state: ProjectsState): any {
        const params = {
            pagination: true,
            page: state.page,
            itemsPerPage: state.itemsPerPage,
            active: state.activeFilter,
            company: state.companyFilter,
            name: state.nameFilter,
        }

        if (state.orderField && state.orderDirection) {
            params[`order[${state.orderField}]`] = state.orderDirection
        }

        return params
    },
}
